import React, { useEffect, useState } from "react";
import {
	Outlet,
	useLocation,
	useNavigate,
	useSearchParams,
} from "react-router-dom";

import { useAuth } from "../../contexts/AuthContext";
import GlobalLoader from "../GlobalLoader";

const ParamAuth = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	const {
		user,
		isLoadingUser,
		isFetchingUser,
		isRefetchingUser,
		signInWithToken,
	} = useAuth();

	const [isAuthComplete, setIsAuthComplete] = useState(true);

	const targetLocation = location.pathname;

	const loginToken = searchParams.get("login-via-token");

	useEffect(() => {
		const authenticateWithToken = async () => {
			if (loginToken) {
				setIsAuthComplete(false);
				try {
					await signInWithToken(loginToken);
					navigate(targetLocation);
				} catch (error) {
					console.log("Error during login with token:", error);
				}
				setIsAuthComplete(true);
			} else {
				setIsAuthComplete(true);
			}

			// if (loginToken && user) {
			// 	navigate(targetLocation);
			// }
		};

		authenticateWithToken();
	}, []);

	return isAuthComplete ? <Outlet /> : <GlobalLoader show={true} />;
};

export default ParamAuth;
